import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Service from 'services/preference';

export const usePreferenceService = () => {
  const { token } = useSelector((state) => state.user_data);

  const create = async (options = {}) => {
    const { error, payload } = await Service.create({
      ...options,
      token
    });

    if (error) {
      toast.error('Could not create preference');
    }

    return payload;
  };

  const read = async (options = {}) => {
    const { error, payload } = await Service.read({
      ...options,
      token
    });

    if (error) {
      return { preferences: [], size: 0 };
    }

    return { preferences: payload.data, size: payload.meta.size };
  };

  const readById = async (id, options = {}) => {
    const { error, payload } = await Service.readById(id, {
      ...options,
      token
    });

    if (error) {
      return { sentry: null };
    }

    return { sentry: payload.data };
  };

  const search = async (keys, keywords, options = {}) => {
    const { error, payload } = await Service.search(keys, keywords, {
      ...options,
      token
    });
    if (error) {
      return { preferences: [], size: 0 };
    }

    return { preferences: payload.data, size: payload.meta.size };
  };

  const update = async (id, options = {}) => {
    const { error, payload } = await Service.updateById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Could not update preference');
    }

    return payload;
  };

  return { create, read, readById, update, search };
};
